"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _dispatcher = _interopRequireDefault(require("dispatcher/dispatcher"));

var _ActionNamespaces = require("crm_data/actions/ActionNamespaces");

var _LazyValueStore = require("crm_data/store/LazyValueStore");

var _FormsAPI = require("crm_data/forms/FormsAPI");

var _ActionTypes = require("crm_data/actions/ActionTypes");

var addFormToState = function addFormToState(state, form) {
  return state.setIn(['value', form.get('guid')], form);
};

var _default = (0, _LazyValueStore.defineLazyValueStore)({
  fetch: _FormsAPI.fetchTicketForms,
  namespace: _ActionNamespaces.TICKET_FORMS
}).defineResponseTo([_ActionTypes.TICKET_FORMS_CREATE_SUCCEEDED, _ActionTypes.TICKET_FORMS_FORM_ALREADY_EXISTS, _ActionTypes.TICKET_FORMS_UPDATE_SUCCEEDED], addFormToState).defineName('TicketFormStore').register(_dispatcher.default);

exports.default = _default;
module.exports = exports.default;